import React from 'react';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Loader,
  GraphQLErrorWrapper,
} from '../generic';

import { GROUP_INVITE_ACCEPT_MUTATION } from './queries';

const GroupInviteAcceptPage = () => {
  const { t } = useTranslation('translations');
  const { token } = useParams();
  const navigate = useNavigate();

  const [
    groupInviteAcceptMutationAction,
    {
      loading,
      error,
    },
  ] = useMutation(GROUP_INVITE_ACCEPT_MUTATION);

  React.useEffect(() => {
    const runMutation = async () => {
      try {
        const result = await groupInviteAcceptMutationAction({
          variables: {
            input: {
              token,
            },
          },
        });
        if (result.data && result.data.groupInviteAccept) {
          // message.success(t('groupInvites.accept.success'));
          navigate('/groups', { replace: true });
        }
      }
      catch (e) { } // eslint-disable-line
    };

    if (token) {
      runMutation();
    }
  }, [token, navigate, groupInviteAcceptMutationAction, t]);

  if (error) {
    return (
      <GraphQLErrorWrapper error={error} />
    );
  }

  return (
    <Loader loading={loading} />
  );
};

export default GroupInviteAcceptPage;
